import { useRef } from 'react';

import InforCircleIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/information-circle';
import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import BpkTooltip from '@skyscanner/backpack-web/bpk-component-tooltip';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import STYLES from './GreatPricesNote.module.scss';

type Props = {
  label?: string;
  subLabel?: string;
  description?: string;
  className?: string;
};

const cls = cssModules(STYLES);

const GreatPricesNote = ({
  className,
  description,
  label,
  subLabel,
}: Props) => {
  const targetRef = useRef(null);

  return (
    <div className={cls('GreatPricesNote', className)}>
      <BpkText
        textStyle={TEXT_STYLES.caption}
        className={cls('GreatPricesNote__text')}
        color={TEXT_COLORS.textError}
      >
        {label}

        <BpkTooltip
          ariaLabel={description || ''}
          id="great-price-note-tooltip"
          hideOnTouchDevices={false}
          target={
            <span
              ref={targetRef}
              className={cls('GreatPricesNote__tooltip--target')}
            >
              <InforCircleIcon
                className={cls('GreatPricesNote__tooltip--icon')}
              />
            </span>
          }
        >
          <BpkText
            className={cls('GreatPricesNote__tooltip--content')}
            textStyle={TEXT_STYLES.footnote}
            tagName="p"
          >
            {description}
          </BpkText>
        </BpkTooltip>
      </BpkText>

      <BpkText
        textStyle={TEXT_STYLES.caption}
        tagName="p"
        color={TEXT_COLORS.textSecondary}
      >
        {subLabel}
      </BpkText>
    </div>
  );
};

export default GreatPricesNote;
